<template>
  <TinyPropertyStateComponent
    v-if="containsChanges"
    :title="appTranslate('Previous value/status')"
    :property-return="original"
    :show-value-as-html="showValueAsHtml"
    class="deleted"
  />

  <i v-if="shouldShowArrow" class="fa fa-long-arrow-right mx-2 d-inline-flex align-items-center" />

  <TinyPropertyStateComponent :title="appTranslate('New value/status')" :property-return="current" :show-value-as-html="showValueAsHtml" />
</template>

<script lang="ts" setup>
import { useTranslation } from '@/composables/useTranslation'
import { PropertyReturn } from '@/models/Property'
import { computed } from 'vue'
import TinyPropertyStateComponent from './TinyPropertyStateComponent.vue'

const props = defineProps<{
  original?: PropertyReturn
  current?: PropertyReturn
  containsChanges?: boolean
  showValueAsHtml?: boolean
}>()

const { appTranslate } = useTranslation()

const shouldShowArrow = computed(
  () =>
    !!(
      props.containsChanges &&
      (props.original?.displayValue || props.original?.status || props.original?.placeholder) &&
      (props.current?.displayValue || props.current?.status || props.current?.placeholder)
    ),
)
</script>

<style lang="scss" scoped>
.deleted {
  text-decoration: line-through;
}

i {
  opacity: 0.7;
}

.no-status {
  color: var(--text-colour) !important;
  font-style: normal;
}

:deep() {
  p {
    margin-bottom: 0 !important; // remove innate paragraph margin from v-html
  }
}

// .modified-text {
//   color: var(--modified-colour) !important;
// }
</style>
